// src/features/auth/signup/InputField.jsx
import React from 'react';

const InputField = ({ id, label, type = 'text', placeholder, register, validation, errors, autoComplete }) => (
    <div>
        <label htmlFor={id} className="block text-sm font-medium text-surface-600 dark:text-surface-400 mb-1.5">
            {label}
        </label>
        <input
            id={id}
            type={type}
            placeholder={placeholder}
            autoComplete={autoComplete}
            className="input-field"
            {...register(id, validation)}
        />
        {errors[id] && <span className="text-red-500 text-xs mt-1 block">{errors[id].message}</span>}
    </div>
);

export default InputField;
